import AppError from '../errors/AppError';
import { ITiinoOrderVendaStatus } from '../interfaces/ITiinoOrderVendaStatus';

import { useRequest } from './useRequest';

const useTiinoService = () => {
  const request = useRequest<any>();
  const path = 'orders/tiino';

  const sendToTiino = async (oderId: string): Promise<void> => {
    await request
      .put({
        path: `${path}/send-order/${oderId}`,
        sendAuthorization: true,
      })
      .catch(error => {
        throw new AppError(error.message, error.status);
      });

    return;
  };

  const getStatus = async (oderId: string): Promise<ITiinoOrderVendaStatus> => {
    return await request
      .getOne({
        path: `${path}/order/${oderId}/status`,
        sendAuthorization: true,
      })
      .then(result => result)
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  return { sendToTiino, getStatus };
};

export { useTiinoService };
